export type SessionType =
  | 'maximal_strength'
  | 'contact_strength'
  | 'explosive_strength'
  | 'power_endurance'
  | 'continuous_endurance'
  | 'local_endurance'
  | 'static_stretching'
  | 'dynamic_stretching'
  | 'mobility_work'
  | 'technical_training'
  | 'mental_training'
  | 'competition'
  | 'free_outdoor_sport'
  | 'free_outdoor_boulder'
  | 'free_indoor_sport'
  | 'free_indoor_boulder'

export type SessionCategory =
  | 'strength'
  | 'endurance'
  | 'flexibility'
  | 'technique_mindset'
  | 'competition'
  | 'free'

export interface SessionTypeGroup {
  category: SessionCategory
  types: SessionType[]
}

export const SESSION_TYPE_CATEGORIES: SessionTypeGroup[] = [
  {
    category: 'strength',
    types: ['maximal_strength', 'contact_strength', 'explosive_strength'],
  },
  {
    category: 'endurance',
    types: ['power_endurance', 'continuous_endurance', 'local_endurance'],
  },
  {
    category: 'flexibility',
    types: ['static_stretching', 'dynamic_stretching', 'mobility_work'],
  },
  {
    category: 'technique_mindset',
    types: ['technical_training', 'mental_training'],
  },
  {
    category: 'competition',
    types: ['competition'],
  },
  {
    category: 'free',
    types: ['free_outdoor_sport', 'free_outdoor_boulder', 'free_indoor_sport', 'free_indoor_boulder'],
  },
]

export interface TrainingSession {
  id: string
  session_date: string
  session_type: SessionType
  session_type_label: string
  effort: number | null
  duration_minutes: number | null
  note: string | null
  created_at: string
}
